import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function eventsReducer(state = initialState.eventsData, action) {
  if (action.type === types.LOAD_EVENTS_DATA_SUCCESS) {
    return action.eventsData;
  }
  return state;
}
